import { FundingProduct } from '@frontend/components/agromarket/core/access-control'
import { EFinancingOfferType } from '@/types'
import { messages } from './messages'

export const LESSORS_BANK_NAME: Partial<Record<EFinancingOfferType, { name: string; url: string }>> = {
  [EFinancingOfferType.LEASING_ALFA]: { name: messages.products.titles.alfaLeasing, url: 'index/partners/alfa-leasing-short' },
  [EFinancingOfferType.LEASING_INTERLEASING]: {
    name: messages.products.titles.interleasingLeasing,
    url: 'index/partners/interleasing-short',
  },
  [EFinancingOfferType.LEASING_BALTIYSKIY]: {
    name: messages.products.titles.baltiyskiyLeasing,
    url: 'index/partners/baltiyskiy-leasing-short',
  },
  [EFinancingOfferType.LEASING_VTB]: { name: messages.products.titles.vtbLeasing, url: 'index/partners/vtb-short' },
  [EFinancingOfferType.LEASING_RAL]: { name: messages.products.titles.rosAgroLeasing, url: 'index/partners/rosagro-leasing-short' },
  [EFinancingOfferType.LEASING_STONE_XXI]: {
    name: messages.products.titles.stoneXxiLeasing,
    url: 'index/partners/stone-xxi-leasing-short',
  },
  [EFinancingOfferType.SBER_LEASING]: { name: messages.products.titles.sberLeasing, url: 'index/partners/sber-leasing-short' },
  [EFinancingOfferType.LEASING_FLEET_FINANCE]: {
    name: messages.products.titles.fleetFinanceLeasing,
    url: 'index/partners/fleet-finance-leasing-short',
  },
}

export const LEASING_PRODUCT_IDS = [
  FundingProduct.LEASING_INTERLEASING,
  FundingProduct.LEASING_RAL,
  FundingProduct.SBER_LEASING,
  FundingProduct.LEASING_FLEET_FINANCE,
]
